import { Model } from '@vuex-orm/core';
import { uuidv4 } from '../../utils/helpers';

export class Log extends Model {
  // This is the name used as module name of the Vuex Store.
  static entity = 'log';

  static fields() {
    return {
      id: this.attr(() => uuidv4()),
      entity_id: this.attr(() => uuidv4()),
      entity_type: this.attr(null),
      entity: this.morphTo('entity_id', 'entity_type'),
      operation_type: this.attr(null),
      changes: this.attr(null),
      prev_values: this.attr(null),
      ip: this.attr(null),
      created_at: this.attr(null),
    };
  }
}

export default Log;
